import { useQuery, gql, type QueryResult, QueryHookOptions } from '@apollo/react-hooks';
import { getWorkOrder } from '#/graphql/queries';
import type { GetWorkOrderQuery } from '#/graphql/types';
import _ from 'lodash';

export const GET_WORK_ORDER = gql(getWorkOrder);

const useWorkOrderQuery = (id?: string, options?: QueryHookOptions) => {
  const query: QueryResult<GetWorkOrderQuery> = useQuery(
    GET_WORK_ORDER,
    _.merge({ variables: { id }, fetchPolicy: 'cache-and-network' }, options || {}),
  );

  return query;
};

export default useWorkOrderQuery;
